import { Button, Heading, Input, InputGroup, InputRightAddon, Stack } from "@chakra-ui/react";
import { NextSeo } from "next-seo";
import { useRouter } from "next/dist/client/router";
import Image from "next/image";
import React, { useCallback, useState } from "react";

import Layout from "src/components/layouts/Default";

import { WaveTop01 } from "shared/assets/graphics/Waves";
import HeaderImage from "shared/assets/images/props_02.png";
import { isLoggedIn, loggedInEmail, logout } from "shared/auth";
import RegisterForm from "shared/components/RegisterForm";
import logger from "shared/logger";

const LoggedIn = () => {
  const [email, setEmail] = useState("");
  const router = useRouter();

  loggedInEmail()
    .then((v) => setEmail(v ?? ""))
    .catch((e) => logger.warn(e, "failed to get email"));

  const onClick = useCallback(async () => {
    await logout();
    router.push("/join");
  }, [email]);

  return (
    <InputGroup size="lg">
      <Input disabled value={email} />
      <InputRightAddon
        children={
          <Button type="submit" onClick={onClick}>
            Logout
          </Button>
        }
      />
    </InputGroup>
  );
};

const Page = () => {
  const [loggedIn, setLoggedIn] = useState(false);

  isLoggedIn().then((is) => setLoggedIn(is));

  return (
    <main>
      <NextSeo
        title="Download Extension"
        description="Download the Lokalyze extension to get suggestions for local alternatives while you shop"
      />

      <div className="wave">
        <WaveTop01 fill="var(--primary-lighter)" />
      </div>

      <div className="bg"></div>

      <section className="content center pt6 pa4">
        <div className="heading pb4">
          <div className="headingText">
            <Heading size="2xl">Get Lokalyze</Heading>
          </div>
          <div className="headingImage">
            <Image src={HeaderImage} width={1920} height={1080} className="br4" />
          </div>
        </div>

        <Stack
          textAlign="justify"
          spacing={4}
          className="measure center mt2 mb5"
          bg="var(--primary-lightest)"
          borderRadius="2xl"
          padding="6"
          color="white"
        >
          <p>
            Lokalyze is currently in closed testing. To register your interest, as either a shopper
            or retailer, enter your email below and we'll keep you updated on our progress.
          </p>

          {loggedIn ? <LoggedIn /> : <RegisterForm environment="web" />}
        </Stack>
      </section>
      <style jsx>{`
        main {
          height: 100%;
          display: grid;
        }
        main > * {
          grid-row: 1/2;
          grid-column: 1/2;
        }
        .heading {
          max-width: 32em;
          display: grid;
          grid-template-columns: 1fr 1fr 5fr 1fr;
          grid-template-rows: 1fr 1fr 8fr 1fr;
        }
        .headingText {
          grid-row: 2/4;
          grid-column: 1/4;
          justify-self: start;
          align-self: end;
          z-index: 3;
          background-color: var(--alternate);
          color: var(--primary-darker);
          filter: drop-shadow(8px 8px 10px hsla(90, 10%, 10%, 20%));
          padding: 0.5em 1.5em;
          border-radius: 1em;
        }
        .headingImage {
          grid-row: 1/5;
          grid-column: 2/5;

          filter: drop-shadow(8px 8px 10px hsla(90, 10%, 10%, 20%));
        }
        .wave {
          grid-row: 1/2;
          grid-column: 1/2;
          z-index: 2;
        }
        .bg {
          height: 100%;
          width: 100%;
          background-color: var(--primary);
        }
        .content {
          z-index: 3;
        }
        .heading {
          z-index: 4;
        }
        .text {
          max-width: 30em;
          background-color: var(--primary-lightest);
          filter: drop-shadow(8px 8px 10px hsla(90, 10%, 10%, 5%));
          color: var(--highlight);
          padding: 1em;
          border-radius: 1em;
          font-weight: 600;
        }
        @media screen and (max-width: 600px) {
          .heading {
            max-width: 32em;
            display: grid;
            grid-template-columns: 1fr 1fr 5fr 1fr;
            grid-template-rows: 1fr 1fr 8fr 4fr;
          }
          .headingImage {
            grid-row: 1/4;
            grid-column: 1/5;
          }
          .headingText {
            grid-row: 1/5;
            grid-column: 2/5;
          }
        }
      `}</style>
    </main>
  );
};

Page.getLayout = (page) => (
  <Layout navHighlight="var(--primary)" navLogoWhite>
    {page}
  </Layout>
);

export default Page;
